import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Sidebar from "../menu/sidebar/sidebarWeb";
import UserAuthentication from "../userAuthentication";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box, AppBar, Toolbar, IconButton, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SidebarMobile from "../menu/sidebar/sidebarMobile";
import 'dayjs/locale/pt-br';

const theme = createTheme({
    components: {
        MuiButton: {
            defaultProps: {
                size: 'medium',
            },
            styleOverrides: {
                root: {
                    textTransform: "none", 
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
                margin: 'dense',
            },
        },
        MuiSelect: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiFormControl: {
            defaultProps: {
                margin: 'dense',
                size: 'small',
            },
        },
        MuiDatePicker: {
            defaultProps: {
                slotProps: {
                    textField: {
                        size: "small",
                    },
                },
            },
        },
        MuiTimePicker: {
            defaultProps: {
                slotProps: {
                    textField: {
                        size: "small",
                    },
                },
            },
        },
        MuiTimeField: {
            defaultProps: {
                slotProps: {
                    textField: {
                        size: "small",
                    },
                },
            },
        },
    },
});

export default function Layout({ children }) {
    const [isSidebarOpen, setSidebarOpen] = useState(true);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                
                {isDesktop ? (
                    <div className="d-flex bg-light" style={{ minHeight: "100vh" }}>
                        <UserAuthentication />
                        <Sidebar
                            onSelect={(page) => console.log("Selecionado:", page)}
                            isOpen={isSidebarOpen}
                            toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
                        />

                        <div className="flex-grow-1 p-4">
                            <Container fluid> 
                                {children}
                            </Container>
                        </div>
                    </div>
                ) : (
                    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f0f2f5' }}>
                        <UserAuthentication />

                        <AppBar
                            position="static"
                            sx={{
                                backgroundColor: 'white',
                                color: 'black',
                                boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)'
                            }}
                        >
                            <Toolbar>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={() => setMobileMenuOpen(true)}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <SidebarMobile
                            open={isMobileMenuOpen}
                            onClose={() => setMobileMenuOpen(false)}
                        />

                        <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
                            <Container fluid>
                                {children}
                            </Container>
                        </Box>
                    </Box>
                )}

            </LocalizationProvider>
        </ThemeProvider>
    );
}